'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { ArrowLeft, Leaf } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FAFAF5] flex flex-col items-center justify-center p-6 text-center font-body relative overflow-hidden">
      {/* Nature Blurred Background Orbs */}
      <div className="absolute top-10 left-10 w-80 h-80 bg-mid-green/5 rounded-full blur-3xl -z-10 animate-pulse" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber/5 rounded-full blur-3xl -z-10" />

      <div className="max-w-xl bg-white p-10 md:p-14 rounded-[3rem] border border-border/60 shadow-2xl relative overflow-hidden transition-all duration-300 hover:shadow-emerald-900/5">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber via-mid-green to-amber"></div>

        {/* Brand Icon */}
        <div className="w-24 h-24 bg-pale-green rounded-full flex items-center justify-center mx-auto mb-8 shadow-inner relative group">
          <Leaf className="w-12 h-12 text-mid-green group-hover:rotate-12 transition-transform duration-500" />
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-amber rounded-full text-deep-green text-xs font-black flex items-center justify-center shadow-md animate-bounce">
            404
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-display font-black text-deep-green mb-3">
          Lost in the Wilderness
        </h1>
        <div className="h-[2px] w-24 bg-gradient-to-r from-amber via-mid-green to-transparent rounded-full mx-auto my-4" />

        <p className="text-text-muted font-medium text-base leading-relaxed mb-10 max-w-sm mx-auto">
          The page you are looking for has been harvested or does not exist. Let&apos;s guide you back to our fresh organic fields.
        </p>

        {/* Action Button */}
        <Link
          href="/"
          className="inline-flex items-center gap-2.5 px-8 py-4 bg-deep-green text-white font-bold text-sm uppercase tracking-wider rounded-2xl hover:bg-mid-green transition-all duration-300 shadow-lg shadow-deep-green/10 hover:shadow-mid-green/20"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Storefront
        </Link>
      </div>

      <div className="mt-8 text-xs text-text-muted font-semibold tracking-widest uppercase flex items-center gap-1.5">
        <span>Pasumai Virumbi</span>
        <span className="w-1.5 h-1.5 rounded-full bg-amber" />
        <span>100% Pure & Healthy</span>
      </div>
    </div>
  );
}
